import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { getVolumes, updateIssue } from '../../../../entity/volumes/Volumes'
import { MdOutlineModeEdit } from 'react-icons/md'
import EditIssueModal from '../../../../components/EditIssueModal/EditIssueModal'

const EditIssue = ({ issueId, data }) => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)

  const modalHandler = () => {
    setIsOpen(prev => !prev)
  }

  const onEditIssueSubmit = async values => {
    if (values && issueId) {
      await dispatch(updateIssue({ issueId: issueId, issueData: values }))
      dispatch(getVolumes())
      modalHandler()
    }
  }

  return (
    <>
      <MdOutlineModeEdit
        className='hover:cursor-pointer hover:scale-110 transition-all'
        onClick={modalHandler}
      />
      {data && isOpen && (
        <EditIssueModal
          isOpen={isOpen}
          onClose={modalHandler}
          data={data || {}}
          onSubmit={onEditIssueSubmit}
        />
      )}
    </>
  )
}

export default EditIssue
